import React from "react";

export const EmptyState = ({text, type}: {type: string; text: string}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {type === "live" ? (
        <img src={"/empty-live.svg"} alt="" />
      ) : (
        <img src={"/empty-live.svg"} alt="" />
      )}

      <p
        style={{
          fontSize: "1.125rem",
          fontWeight: 500,
          color: "#9CA3AF", // This is the hex equivalent of text-gray-400
        }}
      >
        {text}
      </p>
    </div>
  );
};
